module.exports = __webpack_public_path__ + "static/media/k10.0cd2b2a0.jpg";